
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1363_489)"}},[_c('path',{attrs:{"d":"M10 7.654l5.833 5.428v5.251h-2.5v-4.166H6.667v4.166h-2.5v-5.25L10 7.653zm0-2.276l-7.5 6.979V20h5.833v-4.167h3.334V20H17.5v-7.643L10 5.377zm10 4.745L10 .833 0 10.111l1.134 1.22L10 3.109l8.866 8.236L20 10.124z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1363_489"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    